/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from 'react';

import { defineMessages, useIntl } from 'react-intl';

import { cssMap, cx, jsx } from '@atlaskit/css';
import ArrowRightIcon from '@atlaskit/icon/core/arrow-right';
import { Pressable } from '@atlaskit/primitives/compiled/pressable';
import { Text } from '@atlaskit/primitives/compiled/text';
import { token } from '@atlaskit/tokens';

const i18n = defineMessages({
	label: {
		id: 'ai-smart-button.ai-smart-button.ai-smart-button-ui.quick-input.continue-in-chat.label',
		defaultMessage: 'Continue in chat',
		description: 'Label for continuing a long Rovo quick-input prompt in chat',
	},
});

const styles = cssMap({
	button: {
		display: 'flex',
		alignItems: 'center',
		gap: token('space.100'),
		minHeight: '24px',
		paddingBlock: token('space.050'),
		paddingInline: token('space.100'),
		whiteSpace: 'nowrap',
		color: token('color.text.inverse'),
		backgroundColor: token('color.background.neutral.bold'),
		borderRadius: token('radius.xlarge'),
		cursor: 'pointer',
		'&:hover': {
			backgroundColor: token('color.background.neutral.bold.hovered'),
		},
		'&:active': {
			backgroundColor: token('color.background.neutral.bold.pressed'),
		},
	},
});

const motionStyles = cssMap({
	button: {
		transition: token('motion.button.hovered'),
		'&:active': {
			transition: token('motion.button.pressed'),
		},
	},
});

export function ContinueInChat({ onClick }: { onClick: () => void }): React.JSX.Element {
	const { formatMessage } = useIntl();

	return (
		<Pressable
			xcss={cx(styles.button, motionStyles.button)}
			onClick={onClick}
			testId="rovo-button-continue-in-chat"
			type="button"
		>
			<Text color="inherit">{formatMessage(i18n.label)}</Text>
			<ArrowRightIcon label="" size="small" />
		</Pressable>
	);
}
